import { FC, useRef } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import { FormLabel } from 'components/FormLabel/FormLabel';
import { If } from 'components/Generics';
import RhfRadioGroup from 'components/RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { RHFToothChart2 } from 'components/ToothChart2/RHFToothChart2';
import {
  SPACING_INSTRUCTIONS_OPTIONS,
  SPACING_OPTIONS,
  SPACING_VALUES,
  TOOTH_SPACING_OPTIONS,
  TOOTH_SPACING_VALUES
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

interface Props {
  isDisabled?: boolean;
}
const Spacing: FC<Props> = ({ isDisabled }) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchSpacing = watch(
    'treatmentSpecifications.ZenClearUltra.spacing.Spacing'
  );
  const watchToothSpacing = watch(
    'treatmentSpecifications.ZenClearUltra.spacing.toothSpacing.space'
  );
  const fieldError = _.get(
    errors,
    'treatmentSpecifications.ZenClearUltra.spacing'
  );
  const toothChartRef = useRef<HTMLDivElement>(null);
  return (
    <div>
      <FormLabel
        label={translate('prescription.step14_spacing')}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={'spacing'}
      />
      <RhfRadioGroup
        inputProps={{ disabled: isDisabled }}
        options={SPACING_OPTIONS}
        name='treatmentSpecifications.ZenClearUltra.spacing.Spacing'
        className=' flex flex-col space-y-4'
        radioClassName='border-RADIO_BORDER'
        radioItemFont='md:text-17px text-sm'
      />
      <If condition={watchSpacing === SPACING_VALUES.INSTRUCTIONS}>
        <div className='bg-GRAY5 p-4 rounded-2xl mt-2 '>
          <div className='flex flex-col'>
            <p className='text-14px mb-2'>
              {translate('prescription.space_closing_method')}
            </p>
            <div className=' flex flex-row space-x-4 mb-2  '>
              <div className='mt-3 bg-black text-white flex justify-center items-center pt-1  w-6 h-6 rounded-full'>
                <span>U</span>
              </div>
              <RhfRadioGroup
                inputProps={{ disabled: isDisabled }}
                options={SPACING_INSTRUCTIONS_OPTIONS}
                name='treatmentSpecifications.ZenClearUltra.spacing.upper'
                className=' flex flex-row space-x-16'
                radioClassName='border-RADIO_BORDER'
                radioItemFont='md:text-17px text-sm'
              />
            </div>
          </div>

          <div className=' flex flex-row space-x-4   '>
            <div className='mt-3 bg-black text-white flex justify-center items-center pt-1  w-6 h-6 rounded-full'>
              <span>L</span>
            </div>
            <RhfRadioGroup
              inputProps={{ disabled: isDisabled }}
              options={SPACING_INSTRUCTIONS_OPTIONS}
              name='treatmentSpecifications.ZenClearUltra.spacing.lower'
              className=' flex flex-row space-x-16'
              radioClassName='border-RADIO_BORDER'
              radioItemFont='md:text-17px text-sm'
            />
          </div>

          <div className='bg-CHINESE_WHITE p-4 rounded-2xl mt-4 flex flex-col'>
            <p className='text-14px mb-2'>
              {translate('prescription.final_result_expected')}
            </p>
            <RhfRadioGroup
              inputProps={{ disabled: isDisabled }}
              options={TOOTH_SPACING_OPTIONS}
              name='treatmentSpecifications.ZenClearUltra.spacing.toothSpacing.space'
              className=' flex flex-row space-x-16 '
              radioClassName='border-RADIO_BORDER'
              radioItemFont='md:text-17px text-sm'
            />
            {watchToothSpacing === TOOTH_SPACING_VALUES.LEAVE_SPACING && (
              <RHFToothChart2
                disabled={isDisabled}
                name='treatmentSpecifications.ZenClearUltra.spacing.toothSpacing.toothChart'
                toothChartRef={toothChartRef}
              />
            )}
          </div>
        </div>
      </If>
    </div>
  );
};
export default Spacing;
